
import React, { useState } from 'react'
import { Badge, Popover, PopoverBody, PopoverHeader } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

/**
 * CarfaxWarningIndicator - Warning indicator with claims/estimates breakdown.
 * BRD: "A 'Warning' if there is a Carfax (this should be a hover over) – No need to show if there is no Carfax.
 * If there is a Carfax - need to be able to hover over to show amount – or a way to show claims and estimates separately"
 */
const CarfaxWarningIndicator = ({ 
	id, 
	hasCarfax, 
	carfaxAmount, 
	claimsAmount, 
	estimatesAmount,
	claimsCount,
	incidentDescription
}) =>
{
	const [isOpen, setIsOpen] = useState(false)

	const togglePopover = () => setIsOpen(!isOpen)

	// Don't show anything if no Carfax
	if (!hasCarfax && !carfaxAmount && !claimsAmount && !estimatesAmount)
	{
		return null
	}

	// BRD: Show claims and estimates separately - don't add them together
	const totalClaimsAndEstimates = (claimsAmount || 0) + (estimatesAmount || 0)
	const highestEstimate = estimatesAmount || 0
	const hasAmounts = totalClaimsAndEstimates > 0 || (carfaxAmount || 0) > 0

	return (
		<>
			<Badge
				id={id}
				color="warning"
				className="ms-1"
				style={{ cursor: 'pointer', fontSize: '9px', padding: '2px 4px' }}
				onMouseEnter={() => setIsOpen(true)}
				onMouseLeave={() => setIsOpen(false)}
			>
				<FontAwesomeIcon icon={faExclamationTriangle} size="xs" />
			</Badge>
			<Popover
				placement="top"
				isOpen={isOpen}
				target={id}
				toggle={togglePopover}
			>
				<PopoverHeader className="bg-warning" style={{ fontSize: 'small', padding: '0.4rem 0.6rem' }}>
					<FontAwesomeIcon icon={faExclamationTriangle} className="me-1" />
					CARFAX
				</PopoverHeader>
				<PopoverBody style={{ fontSize: 'small' }}>
					{ !hasAmounts && (
						<div className="mb-1">Carfax report available — see vehicle detail.</div>
					) }
					{ hasAmounts && (
						<div className="mb-1">
							<strong>Total Claims & Estimates:</strong>
							<span className="ms-2 text-danger fw-bold">
								${totalClaimsAndEstimates.toLocaleString()}
							</span>
						</div>
					) }
					{estimatesAmount != null && estimatesAmount > 0 && (
						<div className="mb-1">
							<strong>Highest Estimate:</strong>
							<span className="ms-2">${highestEstimate.toLocaleString()}</span>
						</div>
					)}
					{claimsAmount != null && claimsAmount > 0 && (
						<div className="mb-1">
							<strong>Claims Amount:</strong>
							<span className="ms-2">${claimsAmount.toLocaleString()}</span>
							{claimsCount != null && claimsCount > 0 && (
								<span className="text-muted ms-1">({claimsCount} claim{claimsCount !== 1 ? 's' : ''})</span>
							)}
						</div>
					)}
					{incidentDescription && (
						<div className="mt-2 pt-2 border-top">
							<small className="text-muted">{incidentDescription}</small>
						</div>
					)}
				</PopoverBody>
			</Popover>
		</>
	)
}

export default CarfaxWarningIndicator
